import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core'
import { CommonModule } from '@angular/common';
import { PipesModule } from '@shared/pipe/index.module';
import { ScopeVersion } from '@core/model/scope-version';
import { ScopeRetainedHoursStats } from '@app/features/scope-overview/model/scope-retained-hours-stats.model';
import { SowRetainedHoursStats } from '@app/features/scope-overview/model/sow-retained-hours-stats.model';
import { FormsModule } from '@angular/forms';
import { Money } from '@app/features/scope-overview/model/money.model';
import {
  ScopeUiDropdownComponent
} from '@shared/components/ui-components/scope-ui-dropdown/scope-ui-dropdown.component'
import { ApplicationSetting } from '@core/model/enums/application-setting.enum';
import { SharedModule } from '@shared/shared.module';
import { ExchangeRate } from '@app/features/scope-overview/model/exchange-rate.model';
import { ExchangeRateService } from '@shared/services/exchange-rate.service';

@Component({
  selector: 'details-overview',
  standalone: true,
  imports: [CommonModule, PipesModule, FormsModule, ScopeUiDropdownComponent, SharedModule],
  templateUrl: './details-overview.component.html',
  styleUrls: ['./details-overview.component.scss'],
})
export class DetailsOverviewComponent implements OnChanges {
  expandedMode: boolean = false;
  versionNumbers: number[] = [];
  selectedVersion: number;
  selectedExchangeRate: ExchangeRate;

  @Input() scopeVersion!: ScopeVersion;

  @Input() scopeRetainedHoursStats!: ScopeRetainedHoursStats;

  @Input() sowRetainedHoursStats!: SowRetainedHoursStats;

  @Input() trafficMetadataLookupFields!: any;

  @Input() thirdPartyCostBalance!: Money;

  @Input() exchangeRates!: ExchangeRate[];

  @Output() onVersionChange = new EventEmitter<number>();

  constructor(public exchangeRateService: ExchangeRateService) {}

  ngOnChanges(): void {
    this.generateVersionNumbers();
    this.selectedVersion = this.scopeVersion?.version;
  }

  changeVersion() {
    this.onVersionChange.emit(this.selectedVersion);
  }

  changeCurrency() {
    this.exchangeRateService.exchangeRate = this.selectedExchangeRate;
  }

  versionDisplayFn = (version: number) => {
    return version.toString()
  }

  exchangeRateDisplayFn = (exchangeRate: ExchangeRate) => {
    return exchangeRate.toCurrencyCode
  }

  generateVersionNumbers() {
    const currentVersionNumber = this.scopeVersion.identity.currentVersionNumber;
    this.versionNumbers = Array.from({ length: currentVersionNumber }, (_, i) => i + 1);
  }

  getExternalDropdownDynamicFieldValue = (setting: any) => {
    if (typeof setting === 'object' && setting !== null) {
      return setting?.name || setting?.entityId
    }
    return setting || '--'
  }

  protected readonly ApplicationSetting = ApplicationSetting;
}
